import { API, graphqlOperation } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import moment from "moment";

const initialState = {
  status: "idle",
  items: [],
  item: {},
};

const plhistory = (state = initialState, action) => {
  const convertItem = (item) => ({
    ...item,
    eventTimestamp: moment
      .unix(item.eventTimestamp)
      .format(action.config.FORMAT_DATETIME),
  });

  switch (action.type) {
    case "plhistory/loading":
      return {
        ...state,
        status: "loading",
      };
    case "plhistory/loaded":
      return {
        ...state,
        status: "idle",
        items: action.plhitems.map((item) => convertItem(item)),
      };
    case "plhistory/loadError":
      return {
        ...state,
        status: "idle",
      };
    case "plhistory/dismiss":
      return initialState;
    default:
      return state;
  }
};

export const fetchplhistory =
  (showStatus = true) =>
  async (dispatch, getState) => {
    try {
      if (showStatus) {
        dispatch({ type: "plhistory/loading" });
      }
      const response = await API.graphql(
        graphqlOperation(queries.safeOperatorApi, { action: "listPLHistory" })
      );
      const payload = JSON.parse(response.data.safeOperatorApi);
      let plhistoryItems = [];
      if (!payload || payload.status === "error") {
        throw payload;
      }
      if (payload.status === "success") {
        plhistoryItems = payload.body.plhistory;
      }
      console.log("PL History Records: ", plhistoryItems);
      dispatch({
        type: "plhistory/loaded",
        plhitems: plhistoryItems,
        config: getState().config,
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: "plhistory/loadFailed" });
      dispatch({
        type: "notification/error",
        message: "Error loading history records.",
      });
    }
  };

export default plhistory;
